import {
  AzureOfferPlan,
  AzurePricingType,
  RecurrentPriceModeType,
} from '../../../../modules/privateOffer/reducer'
import { useStyles as usePricingStyles } from '../Sections.styles'
import {
  DetailInfo,
  DetailRow,
} from '../../../../common/components/DetailRow/DetailRow'
import { useStyles } from './PlanBillingTerms.styles'
import { DisplayNumberValue } from '../../../MicrosoftViewPricing/PlanMeteringDimensions/PlanMeteringDimensions'

interface PlanBillingTermsProps {
  plan: AzureOfferPlan
  azurePricingType?: AzurePricingType
  recurrentPriceMode?: RecurrentPriceModeType
}

export const PlanBillingTerms = ({ plan }: PlanBillingTermsProps) => {
  const { classes } = useStyles()
  const { classes: pricingClasses } = usePricingStyles()
  const getContractDuration = () => {
    const prices = plan.pricing?.recurrentPrice?.prices || []
    if (prices.length > 0) {
      const firstPrice = prices[0]
      if (firstPrice?.billingTerm?.value && firstPrice?.billingTerm?.type) {
        return `${firstPrice.billingTerm.value} ${firstPrice.billingTerm.type}`
      }
    }
    return 'Not specified'
  }

  return (
    <div className={classes.container}>
      <div className={pricingClasses.subHeading}>Billing Terms</div>
      <DetailRow
        borderBottom
        className={classes.billingTermsRow}
        props={{ spacing: 4 }}
      >
        <>
          <DetailInfo
            title="Pricing model"
            value={getContractDuration()}
            keyName="contractDuration"
            gridSize={4}
          />
          <DetailInfo
            title="Mark-up"
            value={
              <div className={classes.markupPercentage}>
                <DisplayNumberValue value={plan.markupPercentage as number} />%
              </div>
            }
            keyName="markupPercentage"
            gridSize={4}
            align="left"
          />
        </>
      </DetailRow>
    </div>
  )
}
